import { render, staticRenderFns } from "./ConfirmChatReview.vue?vue&type=template&id=b2d4d76a&"
import script from "./ConfirmChatReview.vue?vue&type=script&lang=ts&"
export * from "./ConfirmChatReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports